import React from 'react';
import Wrapper from '../assets/wrappers/SiteSlider';

import SwachBharat from '../assets/images/sitesLogo/SwachBharat.png';
import DataGov from '../assets/images/sitesLogo/dataGovIn.png';
import MyGov from '../assets/images/sitesLogo/MyGov.png';
import IndiaGov from '../assets/images/sitesLogo/IndiaGov.png';
import DigitalIndia from '../assets/images/sitesLogo/DigitalIndia.png';
import Bhashini from '../assets/images/sitesLogo/bhashini.png';

const logos = [
  { image: SwachBharat, url: 'https://swachhbharatmission.ddws.gov.in/' },
  { image: DataGov, url: 'https://data.gov.in/' },
  { image: MyGov, url: 'https://www.mygov.in/' },
  { image: Bhashini, url: 'https://bhashini.gov.in/' },
  { image: IndiaGov, url: 'https://india.gov.in/' },
  { image: DigitalIndia, url: 'https://www.digitalindia.gov.in/' },
];

const SiteSlider: React.FC = () => {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, url: string) => {
    e.preventDefault();

    const message = `You are being redirected to an external website. Click 'OK' to proceed or 'Cancel' to stay on the current page.`;
    const confirmed = window.confirm(message);

    if (confirmed) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Wrapper>
      <div className="carousel-wrapper">
        <div className="logo-carousel">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <a
                href={logo.url}
                onClick={(e) => handleLinkClick(e, logo.url)}
                className="card"
              >
                <img src={logo.image} alt={`Logo ${index}`} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default SiteSlider;
